import binarySearch from 'binary-search-bounds'
import type {MouseEventHandler} from 'react'

export function matchName(name: string | null | undefined, searchQuery: string): boolean {
  return name != null && name.trim().toLowerCase().includes(searchQuery.trim().toLowerCase())
}

export function insertSorted<T>(
  array: readonly T[],
  item: T,
  compareFn: (i1: T, i2: T) => number,
): T[] {
  if (array.length === 0) {
    return [item]
  }
  const result = [...array]

  result.splice(binarySearch.gt(result, item, compareFn), 0, item)
  return result
}

export const stopPropagation: MouseEventHandler<HTMLElement> = e => {
  e.stopPropagation()
}
